import { useCallback } from 'react';
import { Box, DefaultMantineColor, Group, Radio } from '@mantine/core';
import { TFunction } from 'i18next';

import InputLabel from 'components/input-label';
import ErrorText from 'components/error-text';

interface YesNoRadioButtonProps {
  color?: DefaultMantineColor;
  disabled?: boolean;
  form: any;
  info?: string;
  label: string;
  name: string;
  required?: boolean;
  t: TFunction;
}

const YesNoRadioButton = ({
  color = '#75AD53',
  disabled,
  form,
  info,
  label,
  name,
  required,
  t
}: YesNoRadioButtonProps) => {
  const checked = useCallback((val: boolean) => form.getInputProps(name).value === val || form.getInputProps(name).defaultValue === val, [form]);

  return (
    <Box mb={6}>
      <InputLabel label={label} required={required} info={info} />
      <Group>
        <Radio color={color} checked={checked(true)} onChange={() => form.setFieldValue(name, true)} label={t('input.radio.true')} disabled={disabled} />
        <Radio color={color} checked={checked(false)} onChange={() => form.setFieldValue(name, false)} label={t('input.radio.false')} disabled={disabled} />
      </Group>
      {form.errors[name] ? <ErrorText label={form.errors[name]} /> : undefined}
    </Box>
  )
}

export default YesNoRadioButton;